import { defaultHttpClient } from '../../httpClient';
import type { GetGoodsListRequest, GetGoodsListResponse } from './types';

export const getGoodsList = (params: GetGoodsListRequest) => {
  const { type, goods_sno, last_sno, position, from, delivery_type, per_page } =
    params;

  return defaultHttpClient
    .request<GetGoodsListResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goods_sno}/${type}/`,
      params: {
        ...(last_sno != null && { last_sno }),
        ...(position != null && { position }),
        ...(from != null && { from }),
        ...(delivery_type != null && { 'delivery_type[]': delivery_type }),
        ...(per_page != null && { per_page }),
      },
    })
    .then(result => result.data);
};
